import AdminNavbar from "components/Layout/Navbars/AdminNavbar.js";
import Sidebar from "components/Layout/Sidebar";
import { useEffect, useRef, useState } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NextLogo from "../../src/assets/img/Mpink.png";
import { reRegisterSnapshot } from "store/actions/authActions";
import Loader from "components/shared/Loader";
import LanguageSelector from "components/Layout/Navbars/LanguageSelector";
import Subscription from "views/Subscription";
import routes from "../routes/index";
import { getFilteredRoutes } from "utils/getFilteredRoutes";

const Adminlayout = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const mainContent = useRef(null);

  const { uid, user, userPermissions } = useSelector((state) => state.auth);
  const { restaurantMedia } = useSelector((state) => state.restaurant);

  const [hide, setHide] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const filteredRoutes = getFilteredRoutes({
    routes,
    user,
    permissions: userPermissions,
  });

  const isSubscribed =
    user?.type !== "restaurant" || user?.subScriptionStatus === "subscribe";
  const checkSubscription = !isSubscribed && user?.type === "restaurant";

  useEffect(() => {
    if (uid && user?.type) {
      dispatch(reRegisterSnapshot(uid, user?.type))
        .catch(() => history.push("/auth/login"))
        .finally(() => setIsLoading(false));
    }
  }, [uid, user?.type]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {isSubscribed && (
            <LanguageSelector languages={restaurantMedia.languages} />
          )}
          <Sidebar
            {...props}
            routes={routes}
            logo={{
              innerLink: "/admin/index",
              imgSrc: restaurantMedia?.logo || NextLogo,
              imgAlt: "logo",
            }}
            hide={hide}
            setHide={setHide}
          />
          <div ref={mainContent} className="main-content pb-4">
            <AdminNavbar
              {...props}
              hide={hide}
              setHide={setHide}
              isSubscribed={isSubscribed}
            />
            <Switch>
              {checkSubscription && (
                <Route path="/admin/subscriptions" component={Subscription} />
              )}
              {filteredRoutes.map((route, key) => (
                <Route
                  key={key}
                  path={route.path}
                  exact={route.exact}
                  component={route.component}
                />
              ))}
              <Redirect
                to={
                  checkSubscription
                    ? "/admin/subscriptions"
                    : filteredRoutes?.length > 0
                    ? filteredRoutes[0]?.path
                    : "/admin/index"
                }
              />
            </Switch>
          </div>
        </>
      )}
    </>
  );
};

export default Adminlayout;
